import { useCallback, useEffect, useRef, useState } from 'react';
import releaseMediaElement from '~/utilities/releaseMediaElement';

/**
 * A custom hook for managing video elements
 * @returns An object containing the video ref, loading state, and handler function
 */
export default function useVideo() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const currentVideoRef = videoRef.current;

    return () => {
      releaseMediaElement(currentVideoRef);
    };
  }, []);

  const handleVideoLoaded = useCallback(() => {
    setVideoLoaded(true);
  }, []);

  return {
    videoRef,
    videoLoaded,
    handleVideoLoaded
  };
}
